import { AxiosResponse } from 'axios';
import api from './api';
import { Limits, Sorting } from '../types/sort';

export interface Measurement {
    device: number;
    sensor: number;
    measure: Date;
    transaction: Date;
    overdue: boolean;
    values: number[];
    depths: number[];
}

export interface Filter {
    node?: number;
    dev?: number[];
    sns?: number[];
    lo?: number[];
    ov?: boolean;
    fr?: Date;
    to?: Date;
}

interface RequestFilter {
    node?: number;
    dev?: string;
    sns?: string;
    lo?: string;
    ov?: string;
    fr?: string;
    to?: string;
}

function toRequestFilter(filter: Filter): RequestFilter {
    // prettier-ignore
    return {
        node: filter.node ? filter.node             : undefined,
        dev:  filter.dev  ? filter.dev.join(',')    : undefined,
        sns:  filter.sns  ? filter.sns.join(',')    : undefined,
        lo:   filter.lo   ? filter.lo.join(',')     : undefined,
        ov:   filter.ov != null ? String(filter.ov) : undefined,
        fr:   filter.fr   ? filter.fr.toISOString() : undefined,
        to:   filter.to   ? filter.to.toISOString() : undefined,
    }
}

export type SortingColumn = 'device' | 'sensor' | 'measure' | 'transaction' | 'overdue';
export type MSorting = Sorting<SortingColumn>;

//=================================================================================================
export class MeasureService {
    static async getMeasures(
        filter: Filter,
        sorting: MSorting,
        limit: Limits | undefined = undefined,
    ): Promise<AxiosResponse<Measurement[]>> {
        const rFilter = toRequestFilter(filter);
        let params: any = { ...rFilter, ...sorting };
        if (limit) {
            params.limit = limit.limit;
            params.offset = limit.offset;
        }
        return await api.get('/measurement', { params });
    }

    static async size(filter: Filter): Promise<AxiosResponse> {
        const rFilter = toRequestFilter(filter);
        return await api.get('/measurement/size', { params: { ...rFilter } });
    }
}
